import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import {Action} from '../../../system/buttons';

export default class MinecraftWidgetEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props.configuration};
  }

  handleChange = (property) => (value) => {
    let f = {};
    f[property] = value;
    this.setState(f);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate(this.state);
    }
  }

  render() {
    return (
      <>
        <BasicFormElement label={'Animate'}>
          <Form.Check
            type="checkbox"
            onChange={(e) => this.setState({animate: !this.state.animate})}
            checked={this.state.animate}
          />
        </BasicFormElement>
        <BasicFormElement label={'Show calories'}>
          <Form.Check
            type="checkbox"
            onChange={(e) =>
              this.setState({showCalories: !this.state.showCalories})
            }
            checked={this.state.showCalories}
          />
        </BasicFormElement>

        <BasicFormElement label={'Age'}>
          <Form.Control
            type="number"
            value={this.state.age}
            onChange={(e) => this.handleChange('age')(e.target.value)}
          />
        </BasicFormElement>

        <BasicFormElement label={'Weight(in kg)'}>
          <Form.Control
            type="number"
            value={this.state.weight}
            onChange={(e) => this.handleChange('weight')(e.target.value)}
          />
        </BasicFormElement>

        <Action onClick={() => this.props.onSave(this.state)}>
          Save settings
        </Action>
      </>
    );
  }
}

const BasicFormElement = ({label, children}) => {
  return (
    <Form.Group as={Row}>
      <Form.Label column sm="2">
        {label}
      </Form.Label>
      <Col sm="3">{children}</Col>
    </Form.Group>
  );
};
